enum CATEGORIAS_PUNTO {
  ACTA_DE_INSPECCION = 1,
  ACTA_DE_CONSTATACION = 2,
  ACTA_INFORMATIVA = 3,
  ACTA_DE_AUDITORIA = 4,
  EXPLOTACION_IRREGULAR = 5,
  ACOPIO_IRREGULAR = 6,
  DENUNCIA = 7,
  DUCTO = 8,
  TENDIDO_ELECTRICO = 9,
  CUBICAJE = 10,
  RUTA = 11,
  CUERPO_DE_AGUA = 12,
  VISITA = 13,
  OTRO = 14,
};

const getCategoriaPunto = (idCategoria: number | undefined) => {
  if (idCategoria) {

    let categoria = '';
    switch (idCategoria) {
      case 1:
        categoria = 'Acta de inspeccion';
        break;
      case 2:
        categoria = 'Acta de constatacion';
        break;
      case 3:
        categoria = 'Acta informativa';
        break;
      case 4:
        categoria = 'Acta de auditoria';
        break;
      case 5:
        categoria = 'Explotacion irregular';
        break;
      case 6:
        categoria = 'Acopio irregular';
        break;
      case 7:
        categoria = 'Denuncia';
        break;
      case 8:
        categoria = 'Ducto';
        break;
      case 9:
        categoria = 'Tendido electrico';
        break;
      case 10:
        categoria = 'Cubicaje';
        break;
      case 11:
        categoria = 'Ruta';
        break;
      case 12:
        categoria = 'Cuerpo de agua';
        break;
      case 13:
        categoria = 'Visita';
        break;
      case 14:
        categoria = 'Otro';
        break;
      default:
        categoria = '';
        break;
    }
    return categoria;
  }
};

export {
  getCategoriaPunto,
  CATEGORIAS_PUNTO,
};

export const CategoriasPunto = Object.values(CATEGORIAS_PUNTO)
  .filter((v: any) => getCategoriaPunto(v))
  .map((id: any) => ({
    id,
    label: getCategoriaPunto(id),
  }));
